module.exports = __webpack_public_path__ + "img/Te libera de la gestión de cobranza.4fe818a4.svg";